import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import systemReducer from "./systemSlice";

export default configureStore({
  reducer: {
    user: userReducer,
    system: systemReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
